import React, { useEffect, useState } from 'react';

import Tooltip from "../tooltip";

import Button from '../../components/button/button_v2';

import DispGooglePlay from "../../assets/icons/disponivel-google-play.svg";
import DispAppStore from "../../assets/icons/disponivel-app-store.svg";
import CompendioCelular from '../../assets/compendio-celular.png';

import * as S from './styles';
import { theme } from '../../styles/theme';


const StepsAndPreview = ({ ...props }) => {
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 767);

    useEffect(() => {
        const handleMouseMove = (e) => {
            setMousePosition({
                x: e.clientX,
                y: e.clientY
            });
        };

        window.addEventListener('mousemove', handleMouseMove);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    useEffect(() => {
        const onResize = () => setIsDesktop(window.innerWidth > 767);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    return (
        <S.ContainerStepsAndPreview>
            <h2>Decisões mais sustentáveis na emissão do Receituário Agronômico</h2>

            <S.ContainerPreview>
                <S.ContainerPreviewVideo>
                    <iframe
                        src="https://www.youtube.com/embed/EkdFZxWNQak?start=29&autoplay=1&mute=1&controls=0&disablekb=1&rel=0&modestbranding=1&showinfo=0&loop=1&playlist=EkdFZxWNQak"
                        title="Emita um Receituário Agronômico em menos de 1 minuto"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />

                    <S.ContainerImage>
                        <img
                            src={CompendioCelular}
                            alt="Imagem de celular"
                            style={{

                                transform: `rotateX(${(mousePosition.y - window.innerHeight / 2) * 0.02}deg) rotateY(${(mousePosition.x - window.innerWidth / 2) * -0.02}deg)`,
                                transition: 'transform 0.2s ease-out',
                            }}
                        />
                    </S.ContainerImage>
                </S.ContainerPreviewVideo>

                <S.ContainerSteps>
                    <S.Steps>
                        <h3>Passo 1</h3>

                        <p>Selecione a <b>Cultura</b>, a <b>Praga</b> e <b>UF</b> de aplicação. Nosso sistema faz a correlação dos dados e exibe apenas os produtos permitidos no seu caso.</p>

                        <h3>Passo 2</h3>

                        <p>Selecione os dados do <b>Responsável Técnico</b> pela emissão das receitas agronômicas.</p>

                        <h3>Passo 3</h3>

                        <p>Selecione o <b>Produtor</b> e o <b>Local de devolução</b> das embalagens vazias e pronto! Você emitiu seu Receituário em menos de 1 minuto.</p>
                    </S.Steps>

                    <S.ContainerDownload>
                        <a href='#teste-gratis'>
                            <Button
                                width="180px"
                                height="54px"
                                value="COMEÇAR AGORA"
                                outline={false}
                            />
                        </a>

                        <S.DownloadApp>
                            <S.ImgGooglePlay>
                                <Tooltip disabled={!isDesktop} placement="top" interactive={true} delay={[100,0]} content={
                                    <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                                        <img src={`https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=${encodeURIComponent('https://play.google.com/store/apps/details?id=com.clienteagroreceita')}`} alt="QR Google Play" style={{width:'140px',height:'140px'}} />
                                        <span style={{marginTop:'8px',fontFamily:'Lato',fontSize:'12px',color: theme.colors.gray.Cinza_2}}>Baixar agora</span>
                                    </div>
                                }>
                                    <a href="https://play.google.com/store/apps/details?id=com.clienteagroreceita" target="_blank" rel="noopener noreferrer">
                                        <img src={DispGooglePlay} alt="Disponível no Google Play" />
                                    </a>
                                </Tooltip>

                                <Tooltip disabled={!isDesktop} placement="top" interactive={true} delay={[100,0]} content={
                                    <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                                        <img src={`https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=${encodeURIComponent('https://apps.apple.com/us/app/agroreceita-receita-agron%C3%B%C3%Bômica/id1671808311')}`} alt="QR App Store" style={{width:'140px',height:'140px'}} />
                                        <span style={{marginTop:'8px',fontFamily:'Lato',fontSize:'12px',color: theme.colors.gray.Cinza_2}}>Baixar agora</span>
                                    </div>
                                }>
                                    <a className="img-2" href="https://apps.apple.com/us/app/agroreceita-receita-agron%C3%B%C3%Bômica/id1671808311" target="_blank" rel="noopener noreferrer">
                                        <img src={DispAppStore} alt="Disponível na App Store" />
                                    </a>
                                </Tooltip>
                            </S.ImgGooglePlay>
                        </S.DownloadApp>
                    </S.ContainerDownload>
                </S.ContainerSteps>
            </S.ContainerPreview>
        </S.ContainerStepsAndPreview>
    );
}

export default StepsAndPreview;
